import styled from 'styled-components';

import { breakpoints, SkeletonElement } from '@notino/react-styleguide-v20';

export const StyledButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${breakpoints.md}) {
    justify-content: space-between;
    flex-direction: row;
  }
`;

export const StyledButton = styled(SkeletonElement)`
  margin-top: 1rem;

  @media (min-width: ${breakpoints.md}) {
    width: 200px;
  }
`;
